import axios from "axios";

const fileUploaderUrl = process.env.REACT_APP_ARTIFACTS;
export const uploadFile = (fmData, config) => {
  return axios.post(fileUploaderUrl, fmData, config);
};
